import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration } from '@/components/ui/Illustration/Illustration';
import { captureAnalyticsEvent } from '@/lib/mixpanel';
import { useAuthStore } from '@/stores/authStore';

interface NoSessionsLeftStepProps {
  onClose: () => void;
}

export const NoSessionsLeftStep = ({ onClose }: NoSessionsLeftStepProps) => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'scheduleDialog.steps.noSessionsLeftStep' });

  const { userData } = useAuthStore();
  const center = userData?.center;

  const students = userData?.students ?? [];
  const hasSingleStudent = students.length === 1;

  return (
    <>
      <DialogBody>
        <div className='-mt-16 flex flex-1 flex-col items-center justify-center text-center'>
          <Illustration name='skater' className='m-3 w-[127px]' />
          <h3 className='text-heading-m-semibold mt-6 mb-4 w-[320px] max-w-full'>
            {hasSingleStudent ? t('singleStudent.title') : t('multipleStudents.title')}
          </h3>
          <p className='text-text-default-secondary w-[320px] max-w-full'>
            {hasSingleStudent ? t('singleStudent.description', { studentName: students[0].firstName }) : t('multipleStudents.description')}
          </p>
        </div>
      </DialogBody>
      <DialogFooter className='shrink-0 flex-col! gap-3 p-6'>
        <Button
          className='w-full'
          variant='text-secondary'
          asChild
          onClick={() => {
            void captureAnalyticsEvent('contactcenter_clicked', { location: 'scheduling-no_sessions_left' });
          }}
        >
          <a href={`mailto:${center?.email}`} className='flex items-center gap-2'>
            <Mail className='text-text-default-secondary size-5' />
            {t('contactButton.label')}
          </a>
        </Button>
        <Button onClick={onClose} className='w-full'>
          {t('closeButton.label')}
        </Button>
      </DialogFooter>
    </>
  );
};
